import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as serviceWorker from "@_core/serviceWorker";
import Routes from "@_core/Routes";
import { Store } from "@_core/Store";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Suspense fallback="loading">
    <Provider store={Store}>
      <Routes />
    </Provider>
  </Suspense>,
);

serviceWorker.unregister();
